import React, { useState, useContext, useEffect, useCallback } from 'react'

import StudentNav from '../Navbars/StudentNav'
import AdminNav from '../Navbars/AdminNav'
import GuestNav from '../Navbars/GuestNav';
import TeacherNav from '../Navbars/TeacherNav';
import Footer from '../Footer'
import UserCard from './UserCard';
import './User.css'
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import axios from 'axios';
import { ClipLoader } from 'react-spinners';


const User = () => {
  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);

  const [users, setUsers] = useState([]);
  const [usersLoaded, setUsersLoaded] = useState(false);
  const [showClosed, setShowClosed] = useState(false);

  // State for search filters
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedSchool, setSelectedSchool] = useState('');

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: 'include',
      }).then(response => {
        console.log("Response:", response);
        response.json().then(userInfo => {
          console.log("userinfo:", userInfo);
          setUserInfo(userInfo);

          if (userInfo?.usertype) {
            const uType = userInfo?.usertype;
            setUserRole(uType);
          }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable
          console.log("Uname in user.js: ", uname);
          //  console.log("Avatar in: ", avatar);

        })
          .catch(err => console.log("Error in useeffect:", err))
      });
    }
    fetchData();
  }, []);

  const fetchUsers = useCallback(async (search = searchTerm, role = selectedRole, school = selectedSchool, closed = showClosed) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (search) queryParams.append('searchTerm', search);
      if (role) queryParams.append('role', role);
      if (school) queryParams.append('school', school);
      queryParams.append('deactivated', closed ? '1' : '0');

      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUsers?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();

      if (data.users) {
        const formattedUsers = data.users.map((user) => ({
          ...user,
          dateofbirth: user.dateofbirth ? new Date(user.dateofbirth).toLocaleDateString('en-US', {
            month: 'long', day: 'numeric', year: 'numeric'
          }) : 'N/A',
        }));
        setUsers(formattedUsers);
        setUsersLoaded(true);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, selectedRole, selectedSchool, showClosed]);

  useEffect(() => {
    if (searchTerm || selectedRole || selectedSchool || showClosed) {
      const delayDebounceFn = setTimeout(() => {
        fetchUsers();
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    }
    // Removed the else if block that was clearing users when filters were empty
    // This was causing users to disappear after clicking "Load All Users"
  }, [searchTerm, selectedRole, selectedSchool, showClosed, fetchUsers]);

  const handleLoadUsers = () => {
    fetchUsers('', '', '', false);
  };

  const handleToggleClosed = () => {
    setShowClosed(!showClosed);
  };

  const handleCloseView = () => {
    setUsersLoaded(false);
    setUsers([]);
    setSearchTerm('');
    setSelectedRole('');
    setSelectedSchool('');
  };


  const navigate = useNavigate();

  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  const onLogin = (usertype) => {

    setUserRole(usertype);
  };

  async function onLogout() {
    console.log("inside Onlogout.");
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    console.log("navigating");
    navigate('/');
    // console.log("navigated");
    setUserRole('guest');
  }

  const updateTable = async (userId, userType, userPreviousType) => {

    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/setTables/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usertype: userType, userPreviousType: userPreviousType }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response of the additional API call
      })
      .catch((error) => {
        console.error('Error in additional API call:', error);
      });
    // }
  }
  //Update user's type  i.e Student,Teacher,Admin
  const updateUserType = async (userId, userType, userPreviousType) => {

    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/updateType/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usertype: userType }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Update the user's usertype in the local state
        const updatedUsers = users.map((user) =>
          user.id === userId ? { ...user, usertype: userType } : user
        );
        setUsers(updatedUsers);
        updateTable(userId, userType, userPreviousType);


      })

      .catch((error) => {
        console.error('Error updating user usertype:', error);
      });
  };
  const updateUserStatus = async (userId, userStatus) => {
    console.log('inside updateUserStatus')

    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/updateUserStatus/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userstatus: userStatus }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Update the user's usertype in the local state
        const updatedUsers = users.map((user) =>
          user.id === userId ? { ...user, deactivated: userStatus } : user
        );
        setUsers(updatedUsers);
      })
      .catch((error) => {
        console.error('Error updating user usertype:', error);
      });
  };

  return (
    <>
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && (
        <>
          {isGuest && <GuestNav onLogin={onLogin} />}

        </>
      )}

      {/* Search Bars */}
      <div className="search-filters-container">
        <div className="search-filters">
          <input
            type="text"
            placeholder="Type to search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <select
            className="MAdropdown-menu"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="">Filter by Role</option>
            <option value="Admin">Admin</option>
            <option value="Teacher">Teacher</option>
            <option value="Student">Student</option>
          </select>

          <select
            className="MAdropdown-menu"
            value={selectedSchool}
            onChange={(e) => setSelectedSchool(e.target.value)}
          >
            <option value="">Filter by School</option>
            <option value="Bascule Faisal Town">Bascule Faisal Town</option>
            <option value="Bascule Johar Town">Bascule Johar Town</option>
          </select>
        </div>
      </div>

      {/* Message Box and Action Buttons */}
      <div style={{ textAlign: 'center', margin: '20px 0' }}>

        {/* Case 1: Initial State - No Users Loaded AND No Search Term */}
        {!usersLoaded && !searchTerm && (
          <div style={{
            border: '2px solid #e0e0e0',
            padding: '40px',
            borderRadius: '12px',
            display: 'inline-block',
            backgroundColor: '#fff',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            maxWidth: '500px',
            width: '90%'
          }}>
            <h3 style={{ color: '#333', marginBottom: '10px' }}>Welcome to User Management</h3>
            <p style={{ marginBottom: '25px', color: '#555', fontSize: '15px' }}>
              To search for a user, please select a <strong>User Type</strong> or use the <strong>Search Box</strong>.
            </p>
            <button
              onClick={handleLoadUsers}
              style={{
                padding: '12px 25px',
                backgroundColor: 'rgb(3, 180, 198)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '15px',
                cursor: 'pointer',
                fontWeight: '500',
                transition: 'background-color 0.2s'
              }}
            >
              Load All Users
            </button>
          </div>
        )}

        {/* Case 2: Users Loaded (Active View) */}
        {usersLoaded && !showClosed && (
          <div style={{ marginTop: '10px' }}>
            <button
              onClick={handleCloseView}
              style={{
                padding: '10px 20px',
                backgroundColor: '#dc3545', // Red for Close Action
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Close Users
            </button>
          </div>
        )}

        {/* Case 3: Closed Users View */}
        {showClosed && (
          <div style={{ marginTop: '10px' }}>
            <button
              onClick={handleCloseView}
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d', // Grey for Close button
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
        )}

      </div>

      {loading ? (
        <div className="loading-container">
          <ClipLoader size={50} color={"rgb(3, 180, 198)"} loading={loading} />
          <p>Please wait...</p>
        </div>
      ) : (
        <div className="MAcards-in-row">
          {users?.length > 0 ? (
            users.map((user, index) => (
              <UserCard
                key={index}
                user={user}
                searchTerm={searchTerm}
                updateUserType={updateUserType}
                updateUserStatus={updateUserStatus}
              />
            ))
          ) : (
            (searchTerm || selectedRole || selectedSchool || showClosed) && <div style={{ textAlign: 'center', width: '100%', padding: '20px' }}>No users found matching your search.</div>
          )}
        </div>



      )}


      <Footer />
    </>
  );
};

export default User
